import { baseClient } from "./baseRequest";

export enum AppHomeEntryType {
  KLYDO_QUERY = "klydo_query",
  ARTIST_QUERY = "artist_query",
  EXTERNAL_LINK = "external_link",
}

export type MetaData = {
  url?: string;
  query?: string;
};

export type AppHomeEntry = {
  id: string;
  type: AppHomeEntryType;
  metadata: MetaData;
  pictureUrl: string;
  active?: boolean;
};

export interface SearchAppHomeEntryOptions {
  skip?: number;
  limit?: number;
  filters?: AppHomeEntrySearchFilters;
}

export type SearchAppHomeEntryInput = {
  query: string;
  options?: SearchAppHomeEntryOptions;
};

export type AppHomeEntrySearchFilters = {
  [K in keyof Pick<AppHomeEntry, "active">]?: AppHomeEntry[K];
};

export type AppHomeEntryClient = {
  searchAppHomeEntries: ({
    query,
    options,
  }: SearchAppHomeEntryInput) => Promise<AppHomeEntry[]>;
  createAppHomeEntry: (entry: Partial<AppHomeEntry>) => Promise<AppHomeEntry>;
  updateAppHomeEntry: (
    id: string,
    entry: AppHomeEntry,
  ) => Promise<AppHomeEntry>;
  deleteAppHomeEntry: (id: string) => Promise<void>;
};

const appHomeEntryClient: AppHomeEntryClient = {
  searchAppHomeEntries: async ({ query, options }) => {
    return baseClient.post<AppHomeEntry[]>({
      url: "/admin/app-home-entries/search",
      body: {
        query,
        options,
      },
    });
  },
  createAppHomeEntry: async (entry) => {
    return baseClient.put<AppHomeEntry>({
      url: "/admin/app-home-entries",
      body: entry,
    });
  },
  updateAppHomeEntry: async (id, entry) => {
    return baseClient.post<AppHomeEntry>({
      url: `/admin/app-home-entries/${id}`,
      body: entry,
    });
  },
  deleteAppHomeEntry: async (id) => {
    return baseClient.delete({
      url: `/admin/app-home-entries/${id}`,
    });
  },
};
export default appHomeEntryClient;
